// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.vrFxCWH4 {
  max-width: 800px;
  margin: 0 auto;
}

.CW07PeW2 {
  font-size: 28px;
  font-weight: 700;
  margin-bottom: 8px;
  color: #e0e0e0;
}

.TlDpzfQw {
  color: #888;
  font-size: 14px;
  margin-bottom: 32px;
}

.Mp1DhhiL {
  background: #1a1a2e;
  border: 1px solid #2a2a4a;
  border-radius: 12px;
  padding: 24px;
  margin-bottom: 20px;
  transition: border-color 0.2s;
}

.Mp1DhhiL:hover {
  border-color: #4ecca3;
}

.dRJm2fkQ {
  opacity: 0.5;
  pointer-events: none;
}

.lVUXpNP0 {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 8px;
}

.xQFzdIpM {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background: #4ecca3;
  color: #0f0f23;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 700;
  font-size: 16px;
  flex-shrink: 0;
}

.dRJm2fkQ .xQFzdIpM {
  background: #555;
}

.Z7npHuYy {
  font-size: 18px;
  font-weight: 600;
  color: #e0e0e0;
}

.AbV8H7V_ {
  color: #888;
  font-size: 13px;
  margin-bottom: 16px;
  padding-left: 48px;
}

.yP134zss {
  height: 4px;
  background: #2a2a4a;
  border-radius: 2px;
  margin-bottom: 16px;
  margin-left: 48px;
  overflow: hidden;
}

.GVfU3AbO {
  height: 100%;
  background: #4ecca3;
  border-radius: 2px;
  transition: width 0.3s;
}

.jI5o5620 {
  list-style: none;
  padding: 0;
  margin: 0;
  padding-left: 48px;
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.j2cKuUQQ {
  display: block;
  padding: 8px 12px;
  border-radius: 6px;
  color: #b0b0b0;
  font-size: 14px;
  text-decoration: none;
  transition: background-color 0.15s, color 0.15s;
}

.j2cKuUQQ:hover {
  background: #2a2a4a;
  color: #e0e0e0;
  text-decoration: none;
}

.v3f9_K95 {
  color: #6a9a8a;
}

.v3f9_K95:hover {
  background: #2a2a4a;
  color: #4ecca3;
  text-decoration: none;
}

.k5cj6ewr {
  font-size: 14px;
  margin-left: 4px;
}

.F1ov4yk8 {
  color: #4ecca3;
  font-weight: 600;
  margin-right: 8px;
}

.pR6obmWV {
  float: right;
  font-size: 12px;
  color: #666;
}

.s9Q8UjpD {
  font-size: 14px;
  margin-left: 4px;
}

.Y23UzmV1 {
  display: flex;
  gap: 24px;
  margin-bottom: 32px;
  padding: 16px 20px;
  background: #1a1a2e;
  border-radius: 8px;
  border: 1px solid #2a2a4a;
}

.aOO9gGnd {
  text-align: center;
}

.PVlzuhqg {
  font-size: 24px;
  font-weight: 700;
  color: #4ecca3;
}

.bFRVZShX {
  font-size: 12px;
  color: #888;
  margin-top: 2px;
}

/* Responsive: 800px breakpoint */
@media (max-width: 800px) {
  .vrFxCWH4 {
    padding: 0 8px;
  }

  .CW07PeW2 {
    font-size: 22px;
  }

  .Mp1DhhiL {
    padding: 16px;
  }

  .jI5o5620 {
    padding-left: 24px;
  }

  .AbV8H7V_ {
    padding-left: 24px;
  }

  .yP134zss {
    margin-left: 24px;
  }

  .Y23UzmV1 {
    flex-wrap: wrap;
    gap: 12px;
  }

  .aOO9gGnd {
    flex: 1;
    min-width: 60px;
  }
}

/* Responsive: 480px phone breakpoint */
@media (max-width: 480px) {
  .CW07PeW2 {
    font-size: 20px;
  }

  .TlDpzfQw {
    margin-bottom: 20px;
  }

  .Mp1DhhiL {
    padding: 12px;
  }

  .lVUXpNP0 {
    gap: 8px;
  }

  .xQFzdIpM {
    width: 28px;
    height: 28px;
    font-size: 13px;
  }

  .Z7npHuYy {
    font-size: 16px;
  }

  .AbV8H7V_ {
    padding-left: 0;
    font-size: 12px;
  }

  .yP134zss {
    margin-left: 0;
  }

  .jI5o5620 {
    padding-left: 8px;
  }

  .j2cKuUQQ {
    padding: 6px 8px;
    font-size: 13px;
  }

  .Y23UzmV1 {
    gap: 8px;
    padding: 12px;
  }

  .PVlzuhqg {
    font-size: 20px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/LessonMap.module.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EAEE,YAAY;EACZ,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;EACT,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,qBAAqB;EACrB,+CAA+C;AACjD;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EAEE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,WAAW;AACb;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,eAAe;AACjB;;AAEA,iCAAiC;AACjC;EACE;IACE,cAAc;EAChB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,SAAS;EACX;;EAEA;IACE,OAAO;IACP,eAAe;EACjB;AACF;;AAEA,uCAAuC;AACvC;EACE;IACE,eAAe;EACjB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,eAAe;EACjB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,gBAAgB;IAChB,eAAe;EACjB;;EAEA;IACE,QAAQ;IACR,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;AACF","sourcesContent":[".container {\n  max-width: 800px;\n  margin: 0 auto;\n}\n\n.title {\n  font-size: 28px;\n  font-weight: 700;\n  margin-bottom: 8px;\n  color: #e0e0e0;\n}\n\n.subtitle {\n  color: #888;\n  font-size: 14px;\n  margin-bottom: 32px;\n}\n\n.moduleCard {\n  background: #1a1a2e;\n  border: 1px solid #2a2a4a;\n  border-radius: 12px;\n  padding: 24px;\n  margin-bottom: 20px;\n  transition: border-color 0.2s;\n}\n\n.moduleCard:hover {\n  border-color: #4ecca3;\n}\n\n.lockedModule {\n  composes: moduleCard;\n  opacity: 0.5;\n  pointer-events: none;\n}\n\n.moduleHeader {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  margin-bottom: 8px;\n}\n\n.moduleNumber {\n  width: 36px;\n  height: 36px;\n  border-radius: 50%;\n  background: #4ecca3;\n  color: #0f0f23;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-weight: 700;\n  font-size: 16px;\n  flex-shrink: 0;\n}\n\n.lockedModule .moduleNumber {\n  background: #555;\n}\n\n.moduleTitle {\n  font-size: 18px;\n  font-weight: 600;\n  color: #e0e0e0;\n}\n\n.moduleDesc {\n  color: #888;\n  font-size: 13px;\n  margin-bottom: 16px;\n  padding-left: 48px;\n}\n\n.progressBar {\n  height: 4px;\n  background: #2a2a4a;\n  border-radius: 2px;\n  margin-bottom: 16px;\n  margin-left: 48px;\n  overflow: hidden;\n}\n\n.progressFill {\n  height: 100%;\n  background: #4ecca3;\n  border-radius: 2px;\n  transition: width 0.3s;\n}\n\n.lessonList {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n  padding-left: 48px;\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.lessonItem {\n  display: block;\n  padding: 8px 12px;\n  border-radius: 6px;\n  color: #b0b0b0;\n  font-size: 14px;\n  text-decoration: none;\n  transition: background-color 0.15s, color 0.15s;\n}\n\n.lessonItem:hover {\n  background: #2a2a4a;\n  color: #e0e0e0;\n  text-decoration: none;\n}\n\n.lessonItemDone {\n  composes: lessonItem;\n  color: #6a9a8a;\n}\n\n.lessonItemDone:hover {\n  background: #2a2a4a;\n  color: #4ecca3;\n  text-decoration: none;\n}\n\n.completeIcon {\n  font-size: 14px;\n  margin-left: 4px;\n}\n\n.lessonNumber {\n  color: #4ecca3;\n  font-weight: 600;\n  margin-right: 8px;\n}\n\n.lessonXp {\n  float: right;\n  font-size: 12px;\n  color: #666;\n}\n\n.lockIcon {\n  font-size: 14px;\n  margin-left: 4px;\n}\n\n.stats {\n  display: flex;\n  gap: 24px;\n  margin-bottom: 32px;\n  padding: 16px 20px;\n  background: #1a1a2e;\n  border-radius: 8px;\n  border: 1px solid #2a2a4a;\n}\n\n.statItem {\n  text-align: center;\n}\n\n.statValue {\n  font-size: 24px;\n  font-weight: 700;\n  color: #4ecca3;\n}\n\n.statLabel {\n  font-size: 12px;\n  color: #888;\n  margin-top: 2px;\n}\n\n/* Responsive: 800px breakpoint */\n@media (max-width: 800px) {\n  .container {\n    padding: 0 8px;\n  }\n\n  .title {\n    font-size: 22px;\n  }\n\n  .moduleCard {\n    padding: 16px;\n  }\n\n  .lessonList {\n    padding-left: 24px;\n  }\n\n  .moduleDesc {\n    padding-left: 24px;\n  }\n\n  .progressBar {\n    margin-left: 24px;\n  }\n\n  .stats {\n    flex-wrap: wrap;\n    gap: 12px;\n  }\n\n  .statItem {\n    flex: 1;\n    min-width: 60px;\n  }\n}\n\n/* Responsive: 480px phone breakpoint */\n@media (max-width: 480px) {\n  .title {\n    font-size: 20px;\n  }\n\n  .subtitle {\n    margin-bottom: 20px;\n  }\n\n  .moduleCard {\n    padding: 12px;\n  }\n\n  .moduleHeader {\n    gap: 8px;\n  }\n\n  .moduleNumber {\n    width: 28px;\n    height: 28px;\n    font-size: 13px;\n  }\n\n  .moduleTitle {\n    font-size: 16px;\n  }\n\n  .moduleDesc {\n    padding-left: 0;\n    font-size: 12px;\n  }\n\n  .progressBar {\n    margin-left: 0;\n  }\n\n  .lessonList {\n    padding-left: 8px;\n  }\n\n  .lessonItem {\n    padding: 6px 8px;\n    font-size: 13px;\n  }\n\n  .stats {\n    gap: 8px;\n    padding: 12px;\n  }\n\n  .statValue {\n    font-size: 20px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `vrFxCWH4`,
	"title": `CW07PeW2`,
	"subtitle": `TlDpzfQw`,
	"moduleCard": `Mp1DhhiL`,
	"lockedModule": `dRJm2fkQ Mp1DhhiL`,
	"moduleHeader": `lVUXpNP0`,
	"moduleNumber": `xQFzdIpM`,
	"moduleTitle": `Z7npHuYy`,
	"moduleDesc": `AbV8H7V_`,
	"progressBar": `yP134zss`,
	"progressFill": `GVfU3AbO`,
	"lessonList": `jI5o5620`,
	"lessonItem": `j2cKuUQQ`,
	"lessonItemDone": `v3f9_K95 j2cKuUQQ`,
	"completeIcon": `k5cj6ewr`,
	"lessonNumber": `F1ov4yk8`,
	"lessonXp": `pR6obmWV`,
	"lockIcon": `s9Q8UjpD`,
	"stats": `Y23UzmV1`,
	"statItem": `aOO9gGnd`,
	"statValue": `PVlzuhqg`,
	"statLabel": `bFRVZShX`
};
export default ___CSS_LOADER_EXPORT___;
